import { render, staticRenderFns } from "./HmFilterMicroShopGoodsDailyNews.vue?vue&type=template&id=ff8a2e30&scoped=true&"
import script from "./HmFilterMicroShopGoodsDailyNews.vue?vue&type=script&lang=js&"
export * from "./HmFilterMicroShopGoodsDailyNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8a2e30",
  null
  
)

component.options.__file = "HmFilterMicroShopGoodsDailyNews.vue"
export default component.exports